/**
 * Asynchronously loads the component for PiecripTopTradersPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripTopTradersPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripTopTradersPage
);
